.vscroll.inner {
    overflow-y: auto;
    height: 100%;
}

.vscroll.external {
    overflow-y: hidden;
}

.vscroll {
    overflow-x: hidden;
    position: relative;
    display: block;
    .vscroll-back {
        width: 1px;
        opacity: 0;
    }
    .vscroll-content {
        top: 0;
        left: 0;
        width: 100%;
        position: absolute;
    }
    .vscroll-content.inner {
        height: 100%;
    }
}

.infinate-finally {
    div[slot='loader'] {
        visibility: hidden;
    }
}
.cleared {
    div[slot='loader'] {
        display: none;
    }
}

virual-scroll {
    height: 100%;
    display: block;
}